import {
  RESERVE_GET_SERVICE_NUMBERS_REQUEST,
  RESERVE_GET_SERVICE_NUMBERS_SUCCESS,
  RESERVE_GET_SERVICE_NUMBERS_ERROR,
  ADD_RESERVE_SERVICE_NUMBERS_REQUEST,
  ADD_RESERVE_SERVICE_NUMBERS_SUCCESS,
  ADD_RESERVE_SERVICE_NUMBERS_ERROR,
  GET_UN_RESERVED_SERVICE_NUMBERS_REQUEST,
  GET_UN_RESERVED_SERVICE_NUMBERS_SUCCESS,
  GET_UN_RESERVED_SERVICE_NUMBERS_ERROR,
  REMOVE_RESERVE_SERVICE_NUMBERS_REQUEST,
  REMOVE_RESERVE_SERVICE_NUMBERS_SUCCESS,
  REMOVE_RESERVE_SERVICE_NUMBERS_ERROR,
  GET_CLEAR_SERVICE_NUMBER,
  GET_NEW_LINE_RESERVED_NUMBERS_REQUEST,
  GET_NEW_LINE_RESERVED_NUMBERS_SUCCESS,
  GET_NEW_LINE_RESERVED_NUMBERS_ERROR,
  IS_RESERVE_NUMBERS_SELECTED
} from './actionTypes';
import { ISvcNumbers } from './models/types';

export const getReserveServiceNumbers = {
  request: (brn: string, reservedBy: string) => ({
    type: RESERVE_GET_SERVICE_NUMBERS_REQUEST,
    brn,
    reservedBy
  }),
  success: (data) => ({ type: RESERVE_GET_SERVICE_NUMBERS_SUCCESS, data }),
  failure: (error) => ({ type: RESERVE_GET_SERVICE_NUMBERS_ERROR, error })
};

export const getNewLineReservedNumbers = {
  request: (reqData) => ({
    type: GET_NEW_LINE_RESERVED_NUMBERS_REQUEST,
    reqData
  }),
  success: (data) => ({ type: GET_NEW_LINE_RESERVED_NUMBERS_SUCCESS, data }),
  failure: (error) => ({ type: GET_NEW_LINE_RESERVED_NUMBERS_ERROR, error })
};

export const addReserveServiceNumbers = {
  request: (reqData: ISvcNumbers) => ({ type: ADD_RESERVE_SERVICE_NUMBERS_REQUEST, ...reqData }),
  success: (data) => ({ type: ADD_RESERVE_SERVICE_NUMBERS_SUCCESS, data }),
  failure: (error) => ({ type: ADD_RESERVE_SERVICE_NUMBERS_ERROR, error })
};

export const getUnReserveServiceNumbers = {
  request: (page: number, size: number) => ({
    type: GET_UN_RESERVED_SERVICE_NUMBERS_REQUEST,
    page: page,
    size: size
  }),
  success: (data) => ({ type: GET_UN_RESERVED_SERVICE_NUMBERS_SUCCESS, data }),
  failure: (error) => ({ type: GET_UN_RESERVED_SERVICE_NUMBERS_ERROR, error })
};

export const clearServiceNumber = {
  request: (data) => ({
    type: GET_CLEAR_SERVICE_NUMBER,
    data
  })
};

export const deleteReserveServiceNumbers = {
  request: (reqData: string[]) => ({ type: REMOVE_RESERVE_SERVICE_NUMBERS_REQUEST, svcNo: reqData }),
  success: (data) => ({ type: REMOVE_RESERVE_SERVICE_NUMBERS_SUCCESS, data }),
  failure: (error) => ({ type: REMOVE_RESERVE_SERVICE_NUMBERS_ERROR, error })
};

export const isReserveSelected = (data: boolean) => {
  return { type: IS_RESERVE_NUMBERS_SELECTED, data };
};
